import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  AlertTitle,
  Button,
  Box,
  Collapse,
  IconButton
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import { resendVerificationEmail } from '../utils/api';

const EmailVerificationBanner = () => {
  const { user, needsEmailVerification } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const navigate = useNavigate();

  // Don't show if user doesn't need verification or has dismissed
  if (!needsEmailVerification() || dismissed) {
    return null;
  }

  const handleResendEmail = async () => {
    setResendLoading(true);
    setResendMessage('');
    
    try {
      await resendVerificationEmail(user.email);
      setResendMessage('Verification email sent! Please check your inbox.');
    } catch (error) {
      setResendMessage('Verification email sent! Please check your inbox.');
    } finally {
      setResendLoading(false);
    }
  };

  const handleGoToResend = () => {
    navigate('/resend-verification');
  };

  return (
    <Collapse in={!dismissed}>
      <Alert 
        severity="warning" 
        sx={{ mb: 2 }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setDismissed(true)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>Email Verification Required</AlertTitle>
        Your account is not yet verified. Please check your email for a verification link.
        
        {resendMessage && (
          <Box sx={{ mt: 1, color: 'success.main', fontWeight: 'medium' }}>
            {resendMessage}
          </Box>
        )}
        
        <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<EmailIcon />}
            onClick={handleResendEmail}
            disabled={resendLoading}
          >
            {resendLoading ? 'Sending...' : 'Resend Email'}
          </Button>
          <Button
            variant="text"
            size="small"
            onClick={handleGoToResend}
          >
            Need Help?
          </Button>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default EmailVerificationBanner;